<mat-menu
  #langMenu="matMenu"
  [hasBackdrop]="true"
  [xPosition]="xPosition"
  class="pencil-mat-menu light-scheme"
>
  <ng-container *ngTemplateOutlet="languageOptions"></ng-container>
</mat-menu>

<ng-template #languageBottomSheet>
  <app-pencil-bottom-sheet-container
    [title]="'Language' | translate"
    [colorScheme]="ColorScheme.LIGHT"
    (closeClicked)="closeBottomSheet()"
  >
    <ng-container *ngTemplateOutlet="languageOptions"></ng-container>
  </app-pencil-bottom-sheet-container>
</ng-template>

<ng-template #languageOptions>
  <ng-container *ngIf="selectedLangCode$ | async as langCode">
    <app-pencil-menu-item
      *ngFor="let option of languageOptions$ | async; trackBy: trackByCode"
      [label]="option.label"
      [selected]="langCode === option.lang.code"
      [renderCheckIcon]="langCode === option.lang.code"
      (clickEvent)="selectLanguage(option.lang)"
      [attr.data-name]="option.dataName"
    ></app-pencil-menu-item>
  </ng-container>
</ng-template>
